import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import cardiacTheme from './cardiacTheme';

/**
 * App-level MUI theme provider for all Cardiac custom UI.
 *
 * Deliberately does NOT render <CssBaseline/> — a global baseline reset would
 * fight the OHIF viewer's own styling. Components opt into the theme via MUI's
 * `sx`/`styled`; page-level surfaces that want a scoped reset can use
 * <ScopedCssBaseline> locally.
 */
const CardiacThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ThemeProvider theme={cardiacTheme}>{children}</ThemeProvider>
);

export default CardiacThemeProvider;
